import React from 'react';
import WidgetTabs from '@pages/AdditionalServices/components/WidgetTabs';

import FormWidget from '../AdditionalServices';
import RootContainer from './StyledComponents';

const Widget = () => {
  // iframe не удалять. Он используется для изолированного вычисления формул в
  // полях дополнительных услуг.
  return (
    <RootContainer>
      <iframe id="a-service-iframe"></iframe>
      <WidgetTabs/>
      <FormWidget/>
    </RootContainer>
  );
};

export default Widget;
